module.exports = __webpack_public_path__ + "static/fxlebot@2x-de242c243a3f773732122c326ebadcaf.jpg";